import type { Theme } from 'theme-ui'

export const theme: Theme = {
  fonts: {
    body: '"Proxima Nova", sans-serif',
    heading: '"Proxima Nova", sans-serif',
    monospace: 'Menlo, monospace',
  },
  colors: {
    text: '#444',
    background: '#fff',
    primary: '#33e',
  },
  text: {
    heading: {
      fontWeight: 'bold',
      letterSpacing: '0.05em',
      mb: 2,
    },
    title: {
      variant: 'text.heading',
      fontSize: 5,
    }
  },
  links: {
    styles: {
      a: {
        color: '#546D49',
      }
    }
  },
  breakpoints: [
    '576px', '768px', '992px', '1200px', '1600px'
  ],
  space: [
    0, 4, 8, 16, 24, 32, 48, 64, 128
  ],
  fontSizes: [
    10, 12, 14, 16, 20, 24, 32, 48, 64
  ],
  sizes: {
    container: 960,
  }
}
